export default __webpack_public_path__ + "static/media/verifiy-check.73e5d6be.svg";